import { Skeleton } from '@mui/material';

import { isTruthy } from 'common';

import { UserTooltip } from './Tooltip';
import { useUserApi } from './useUserApi';
import { formatUserName } from './utils';

interface UserLabelProps {
  userId: string;
  fallbackOnError?: string;
}

export function UserLabel(props: UserLabelProps) {
  const { userId, fallbackOnError } = props;

  const { data, isSuccess, isPending, isError } = useUserApi({ userId });

  if (isTruthy(userId) && isPending) {
    return <Skeleton variant="text" width={128} />;
  }
  if (isError) {
    return <span>{fallbackOnError ?? userId}</span>;
  }
  if (isSuccess) {
    return (
      <UserTooltip user={data}>
        <span>{formatUserName(data)}</span>
      </UserTooltip>
    );
  }
}
